import Types from '../../../actions/Types'

const initialState = null

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.APP.SETSTATUS:
      return action.status
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/app/status.js